import { type ReactNode } from 'react';
import clsx from 'clsx';
import { Avatar } from '@/components/ui/Avatar';
import styles from './UserHeader.module.css';

interface Props {
  name: string;
  username: string | null;
  avatarUrl: string | null;
  rating: number;
  ratingCount: number;
  memberSince?: string;
  actions?: ReactNode;
  className?: string;
}

export const UserHeader = ({
  name,
  username,
  avatarUrl,
  rating,
  ratingCount,
  memberSince,
  actions,
  className,
}: Props) => (
  <div className={clsx(styles.header, className)}>
    <Avatar src={avatarUrl} name={name} size="xl" />

    <div className={styles.info}>
      <h1 className={styles.name}>{name}</h1>
      {username && <p className={styles.username}>@{username}</p>}

      <div className={styles.metaRow}>
        <span className={styles.rating}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          {rating.toFixed(1)}
        </span>
        <span className={styles.dot}>·</span>
        <span className={styles.metaText}>
          {ratingCount} {plural(ratingCount, ['отзыв', 'отзыва', 'отзывов'])}
        </span>
        {memberSince && (
          <>
            <span className={styles.dot}>·</span>
            <span className={styles.metaText}>{formatMemberSince(memberSince)}</span>
          </>
        )}
      </div>
    </div>

    {actions && <div className={styles.actions}>{actions}</div>}
  </div>
);

const plural = (n: number, forms: [string, string, string]) => {
  const last = n % 10;
  const lastTwo = n % 100;
  if (lastTwo >= 11 && lastTwo <= 14) return forms[2];
  if (last === 1) return forms[0];
  if (last >= 2 && last <= 4) return forms[1];
  return forms[2];
};

const formatMemberSince = (iso: string) => {
  const date = new Date(iso);
  const diffDays = Math.floor((Date.now() - date.getTime()) / 86_400_000);
  if (diffDays < 30) return `с нами ${diffDays} дн`;
  if (diffDays < 365) return `с нами ${Math.floor(diffDays / 30)} мес`;
  return `с нами ${Math.floor(diffDays / 365)} г`;
};